import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Import Layout
import Layout from './components/layout/Layout';

// Pages
import Home from './pages/Home';
import VisionMission from './pages/VisionMission';
import Location from './pages/Location';
import Services from './pages/Services';
import Residential from './pages/Residential';
import Respite from './pages/Respite';
import IndependentLiving from './pages/IndependentLiving';
import Fees from './pages/Fees';
import News from './pages/News';
import Events from './pages/Events';
import Policies from './pages/Policies';
import Privacy from './pages/Privacy';
import Links from './pages/Links';
import Contact from './pages/Contact';

const App = () => {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/vision-mission" element={<VisionMission />} />
          <Route path="/location" element={<Location />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/residential" element={<Residential />} />
          <Route path="/services/respite" element={<Respite />} />
          <Route path="/services/independent-living" element={<IndependentLiving />} />
          <Route path="/residential" element={<Residential />} />
          <Route path="/respite" element={<Respite />} />
          <Route path="/independent-living" element={<IndependentLiving />} />
          <Route path="/fees" element={<Fees />} />
          <Route path="/news" element={<News />} />
          <Route path="/events" element={<Events />} />
          <Route path="/policies" element={<Policies />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/links" element={<Links />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </Layout>
    </Router>
  );
};

export default App;
